import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { ApprovedTypesEnum } from 'APIPackage/KnmModule/enums/ApprovedTypesEnum';
import { IKnmPlanReason } from 'APIPackage/KnmModule/interfaces/IKnmPlanReason';

import { IKnmErknmFormChangePlanReason } from '../interfaces/IKnmErknmFormChangePlanReason';

export const convertApproveChangePlanFormValuesToKnmData = (
  values: IKnmErknmFormChangePlanReason,
  changePlanReason?: IKnmPlanReason[],
): IKnm248['approve'] => {
  const {
    approvedChangePlanErknm,
    approveChangePlanDateDecision,
    approveChangePlanNumberDecision,
    approveChangePlanFioSigner,
    approveChangePlanFile,
    approveChangePlanTitleSigner,
  } = values;

  const approvedFromForm = approvedChangePlanErknm?.value ?? null;
  const existingApproveStatus = changePlanReason?.[0]?.approve?.approved ?? null;
  const finalApproveStatus = existingApproveStatus === null ? null : ApprovedTypesEnum.ON_APPROVAL;
  const wasRejected = changePlanReason?.[0]?.approve?.wasRejected || null;

  return {
    approved: approvedFromForm || finalApproveStatus,
    approveRequired: null,
    approveNote: null,
    dateDecision: convertFormDateValueToKnmDataDate(approveChangePlanDateDecision) || null,
    numberDecision: approveChangePlanNumberDecision || null,
    fioSigner: approveChangePlanFioSigner || null,
    titleSigner: approveChangePlanTitleSigner || null,
    noteAppeal: null,
    status: null,
    rejectReasonType: null,
    rejectReasonNote: null,
    dateRejectReason: null,
    prosecutorRegStatus: null,
    note: null,
    appeal: null,
    approveFile: approveChangePlanFile || null,
    isNeedApplyChangesInApprovedPlan: approvedChangePlanErknm
      ? approvedChangePlanErknm.value === ApprovedTypesEnum.APPROVED
      : null,
    wasRejected,
    remarks: null,
  };
};
